<template>
    <div>
        <paid-modal v-if="!is_paid && showPaidModal" :redirect="true" :hot-key="false" @close="showPaidModal = false"/>
        <title>{{ $t('mojefirmy.text_1') }}</title>
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">       
        <div class="cont">
            <div v-if="createEdit == 0">
                <h1>{{ $t('mojefirmy.text_2') }}</h1>
                <h3>
                    {{ $t('mojefirmy.text_3') }}
                </h3>
                <a class="create_item" @click="createEditComapny">
                    <svg class="mr-2" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle;"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                    {{ $t('mojefirmy.text_4') }}
                </a>
                <div v-if="items.length > 0" class="box titles">
                    <div class="nazov">
                        {{ $t('mojefirmy.text_5') }}
                    </div>
                    <div class="slug">
                       Slug
                    </div>
                    <div class="osoba">
                        {{ $t('mojefirmy.text_6') }}
                    </div>
                    <div class="actions"></div>
                </div>
                <div class="box main_company mb-4 mt-4 relative" >
                    <div class="nazov">
                        {{ setTitle(main_company.nazov) }}
                    </div>
                    <div class="slug">
                        {{ main_company.slug }}
                    </div>
                    <div class="osoba">
                        {{ main_company.osoba }}
                    </div>
                    <div class="actions">
                        <div class="vue_show_tooltip"> 
                            <div class="edit_action">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none" @click="editItem(main_company, true)">
                                    <path d="M5.5 1.5H4.5C2 1.5 1 2.5 1 5V8C1 10.5 2 11.5 4.5 11.5H7.5C10 11.5 11 10.5 11 8V7" stroke="#9CA3AF" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.02 2.00999L4.08 5.94999C3.93 6.09999 3.78 6.39499 3.75 6.60999L3.535 8.11499C3.455 8.65999 3.84 9.03999 4.385 8.96499L5.89 8.74999C6.1 8.71999 6.395 8.56999 6.55 8.41999L10.49 4.47999C11.17 3.79999 11.49 3.00999 10.49 2.00999C9.49 1.00999 8.7 1.32999 8.02 2.00999Z" stroke="#9CA3AF" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7.45499 2.57498C7.78999 3.76998 8.72499 4.70498 9.92499 5.04498" stroke="#9CA3AF" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>   
                            <tool-tip class="vue_tooltip hide" side="r" :text="$t('mojefirmy.text_7')"/>
                        </div>
                    </div>
                    <offer-alert-tomany v-if="!is_paid && items.length > 0" class="position-absolute top-50% left-50% -translate-x-1/2 translate-y-10"/>  
                </div>
                <div v-for="item in items" :key="item.id" class="box" :class="{'blur': !is_paid}">
                    <div class="nazov">
                        {{ setTitle(item.nazov) }}
                    </div>
                    <div class="slug">
                        {{ item.slug }}
                    </div>
                    <div class="osoba">
                        {{ item.osoba }}
                    </div>
                    <div v-if="is_paid" class="actions">
                        <div class="vue_show_tooltip"> 
                            <div class="edit_action">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none" @click="editItem(item)">
                                    <path d="M5.5 1.5H4.5C2 1.5 1 2.5 1 5V8C1 10.5 2 11.5 4.5 11.5H7.5C10 11.5 11 10.5 11 8V7" stroke="#9CA3AF" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.02 2.00999L4.08 5.94999C3.93 6.09999 3.78 6.39499 3.75 6.60999L3.535 8.11499C3.455 8.65999 3.84 9.03999 4.385 8.96499L5.89 8.74999C6.1 8.71999 6.395 8.56999 6.55 8.41999L10.49 4.47999C11.17 3.79999 11.49 3.00999 10.49 2.00999C9.49 1.00999 8.7 1.32999 8.02 2.00999Z" stroke="#9CA3AF" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7.45499 2.57498C7.78999 3.76998 8.72499 4.70498 9.92499 5.04498" stroke="#9CA3AF" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>   
                            <tool-tip class="vue_tooltip hide" side="r" :text="$t('mojefirmy.text_7')"/>
                        </div>
                        <div class="vue_show_tooltip">
                            <div class="delete_action">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" @click="deleteItem(item)">
                                    <path d="M10.5 3.49002C8.835 3.32502 7.16 3.24002 5.49 3.24002C4.5 3.24002 3.51 3.29002 2.52 3.39002L1.5 3.49002" stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.25 2.985L4.36 2.33C4.44 1.855 4.5 1.5 5.345 1.5H6.655C7.5 1.5 7.565 1.875 7.64 2.335L7.75 2.985" stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M9.42507 5.07001L9.10007 10.105C9.04507 10.89 9.00007 11.5 7.60507 11.5H4.39507C3.00007 11.5 2.95507 10.89 2.90007 10.105L2.57507 5.07001" stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5.16492 8.75H6.82992" stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.75 6.75H7.25" stroke="#F93C34" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg> 
                            </div>   
                            <tool-tip class="vue_tooltip hide" side="r" :text="$t('mojefirmy.text_8')"/>
                        </div>
                    </div>
                </div>
            </div>
            <create-edit-firma  v-if="createEdit != 0" :user_id="user_id" :status="createEdit" :itemEdit="itemEdit" @save="newItem($event)"/>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import ToolTip from '../../vue_components/ToolTip.vue';
import CreateEditFirma from './components/CreateEditFirma.vue';
import PaidModal from '../../vue_components/PaidModal.vue';
import OfferAlertTomany from '../../offer/OfferTable_components/OffersAlertTomany.vue';
export default {
    components: { ToolTip, CreateEditFirma, PaidModal, OfferAlertTomany },
    props: [ 'user_id', 'data', 'main_company_', 'is_paid'],
    data() {
        return {
            createEdit: 0,
            items: [],
            itemEdit: null,
            main_company: null,
            showPaidModal: false
        }
    },
    created () {
        this.items = this.data;
        this.main_company = this.main_company_;
    },
    methods: {
        createEditComapny(){
            if(!this.is_paid){
                this.showPaidModal = true
            }else{
                this.createEdit = 1
            }
        },
        setTitle(title){
            var len = title == null ? 0 : title.length
            if (len < 23) return title
            return (title).slice(0,23) + '...'
        },
        editItem(item, main = false){
            this.createEdit = 2
            this.itemEdit = item
            this.itemEdit.main = main
        },
        deleteItem(item){
            swal.fire({
                title: this.$t('mojefirmy.text_9'),
                text: this.$t('mojefirmy.text_10'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: this.$t('mojefirmy.text_11'),
                confirmButtonText: this.$t('mojefirmy.text_12')
            }).then(result => {
                if (result.value) {
                    axios.post('/api/deleteMojaFirma', {'id': item.id}).then(() =>{
                        this.$toast.success(this.$t('mojefirmy.text_13'), {
                            timeout: 2038,
                        });           
                        var foundIndex = this.items.findIndex(x => x.id == item.id);
                        this.items.splice(foundIndex, 1)
                    })
                }
            });
        },
        newItem(item) {
            this.$toast.success(this.createEdit == 1 ? this.$t('mojefirmy.text_14') : this.$t('mojefirmy.text_15'), {
                timeout: 2038,
            });
            if(item.main){
                this.main_company = item
            }else{
                var foundIndex = this.items.findIndex(x => x.id == item.id);
                foundIndex == -1 ? this.items.push(item) : this.items[foundIndex] = item
            }
            this.createEdit = 0
        }
    },
}
</script>

<style lang="scss" scoped>
.vue_tooltip .hide{
    display: none;
}
.vue_tooltip .show{
    display: block;
}
.vue_show_tooltip{
    position: relative;
}
.box{
    width: 863px;
    @media (max-width: 1200px){
        width: 95%;
    }
    background: #FFFFFF;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 15px 15px;
    margin: 0px auto 9px auto;
    &.blur{
        filter: blur(10px);
        pointer-events: none;
    }
    &.main_company{
        background: #fcfcfc;
    }
    .osoba{
        margin-left: -5px;
    }
    .nazov, .osoba, .slug{
        display: grid;
        width: 45%;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #212541;
        span{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 14px;
            color: #9CA3AF;
        }
    }
    .actions{
        width: 10%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        svg{
            cursor: pointer;
        }
        .edit_action, .delete_action{
            display: flex;
            width: 24px;
            height: 24px;
            justify-content: center;
            align-items: center;
            border-radius: 24px;
        }
        .edit_action{
            background: var(--gray-100, #F3F4F6);
        }
        .delete_action{
            margin-left: 11px;
            background: var(--red-50, #ffe2e0);
        }
    }
}
.box.titles{
    width: 863px;
    @media (max-width: 1200px){
        width: 95%;
    }
    border-radius: 6px;
    display: flex;
    align-items: center;
    margin: 0px auto 6px auto;
    background: transparent;
    margin-top: 36px;
    padding: 0;
    padding-left: 8px;
    .nazov, .osoba, .slug{
        width: 45%;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #212541;
        opacity: 0.4;
    }
    .actions{
        width: 10%;
    }
}
.cont{
    width: 1188px;
    margin: 0 auto;
    padding: 35px 0;
    @media only screen and (max-width: 1500px) {
        width: 95%;
    }   
    h1{
        @media only screen and (max-width: 600px) {
            width: 90%;
            margin: 0 auto;
        }
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        color: #000000;
    }
    h3{
        width: 700px;
        @media only screen and (max-width: 600px) {
            width: 90%;
        }
        margin: 10px auto 27px auto;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 150%;
        text-align: center;
        color: #9598A7;
    }
    .create_item{
        width: 230px;
        height: 55px;
        margin: 0 auto;
        @media only screen and (max-width: 600px) {    
            margin-top: 25px;
            width: 300px;
        }
        background: #2ED8B6;
        border-radius: 4px;
        font-family: Roboto;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        color: #FFFFFF;
        cursor: pointer;
        transition: .5s all;
        &:hover{
            background: #23caa9;
            color: #FFFFFF;
        }
        &.disabled{
            cursor: no-drop;
            pointer-events: none;
            opacity: 0.3;
        }
    }
}
</style>